import type { ReactNode } from 'react';
import '@/features/guia-interactiva/styles/guia-interactiva.css';
import { useGuiaInteractiva } from '@/features/guia-interactiva/hooks/use-guia-interactiva';
import { GuiaInteractivaContext } from './guia-interactiva-context';

export function GuiaInteractivaProvider({ children }: { children: ReactNode }) {
  const value = useGuiaInteractiva();
  return (
    <GuiaInteractivaContext.Provider value={value}>{children}</GuiaInteractivaContext.Provider>
  );
}
